<!-- Preview Mode -->
<div *ngIf="mode === 'preview'" [ngStyle]="getPreviewStyles()" class="prose max-w-none p-6 rounded-lg">
  <h2 *ngIf="getHeading()" [style.color]="getHeadingColor()" [ngClass]="getTitlePositionClass()" class="text-2xl font-bold mb-4">
    {{ getHeading() }}
  </h2>
  
  <!-- Inline Editor when selected -->
  <div *ngIf="isSelected">
    <editor
      [ngModel]="getContent()"
      (ngModelChange)="onContentChange($event)"
      [init]="editorConfig"
      class="w-full">
    </editor>
  </div>
  
  <!-- Normal Preview when not selected -->
  <div *ngIf="!isSelected" [innerHTML]="getPreviewContent()"></div>
</div>

<!-- Edit Mode - Content Editor (for sidebar) -->
<div *ngIf="mode === 'edit'" class="space-y-4">
  <div>
    <label class="block text-sm font-medium text-gray-300 mb-2">Tekst Inhoud</label>
    <editor
      [ngModel]="getContent()"
      (ngModelChange)="onContentChange($event)"
      [init]="editorConfig"
      class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200">
    </editor>
  </div>
</div>
